// extracted by mini-css-extract-plugin
export default {"homeBody":"Home_homeBody__IBX4+"};